module.exports = __webpack_public_path__ + "img/alert-s.4e2e8809.svg";